import SessionController from '../../../assets/js/controllers/session';


export default class DashboardLaunch {

	static selector = 'dashboard-launch';

	constructor(container) {
		this.el = {
			container,
			button: container.querySelector('button')
		};

		this.addEventListeners();
	}

	#onButtonClick = (e) => {
		e.preventDefault();
		const el = e.currentTarget;
		el.setAttribute('disabled', true);
		fetch('/api/dashboard/token', {
				method: 'GET',
				headers: {
					'Session-Token': sessionStorage.getItem(SessionController.keys.sessionToken)
				}
			})
			.then(response => response.json())
			.then((result) => {
				// TODO allow popup!
				const { code } = result.status;
				if (code === 200) {
					window.open('/dashboard/app', '_blank');
				} else {
					location.reload();
				}
			})
			.finally(() => {
				el.removeAttribute('disabled');
			});
	};

	addEventListeners() {
		this.el.button.addEventListener('click', this.#onButtonClick);
	}

	removeEventListeners() {
		this.el.button.removeEventListener('click', this.#onButtonClick);
	}

	destroy() {
		this.removeEventListeners();
	}

}
